
/**
 * Types related to putting and training results
 */

export interface PuttingResult {
  id: string;
  user_id: string;
  situation_id: number;
  points: number;
  index: number;
  test_date: string;
  test_level?: string;
  test_name?: string;
  test_id?: string;
  metadata?: Record<string, any>; // Add metadata property
}

export interface ChartDataPoint {
  date: string;
  points: number;
  level: string;
  testName: string;
  testId: string;
}

// Mapping for putting test IDs to human-readable names
export const puttingTestNames: Record<string, string> = {
  "putts-plat": "Les putts à plat",
  "putts-montee": "Les putts en montée",
  "putts-descente": "Les Putts en descente",
  "putts-pente": "Les Putts en Pente gauche droite",
  "putts-pente-droite": "Les Putts en Pente droite gauche"
};
